import React from 'react';
export function AuthorInfo() {
  return <div className="flex items-center mt-4" data-id="element-103">
      <div className="rounded-full w-14 h-14 flex items-center justify-center overflow-hidden border-2 border-red-500 shadow-md" data-id="element-104">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Sophia Weston" className="w-full h-full object-cover" data-id="element-105" />
      </div>
      <div className="ml-3" data-id="element-106">
        <p className="font-bold text-sm text-red-600" data-id="element-107">Sophia Weston</p>
        <p className="text-xs text-gray-700 font-medium" data-id="element-108">
          Psychologist & Reconquest Specialist
        </p>
      </div>
    </div>;
}